export default "/packs/images/home-workout~45b80680e5e5daa9c813243e09480c2f.jpg";